<script setup lang="ts">
import HeaderVue from "./PsHeader.vue";
import FooterVue from "@/views/components/Footer.vue";
import CookieConsentBanner from '@/views/components/CookieConsentBanner.vue';

const props = withDefaults(
  defineProps<{
    canShowFooter?: boolean;
  }>(),
  {
    canShowFooter: true,
  }
);
</script>

<template>
  <HeaderVue />

  <slot></slot>

  <FooterVue v-if="props.canShowFooter"/>
  <CookieConsentBanner></CookieConsentBanner>
</template>
